
import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import { useLocation } from "react-router-dom";
import formatDate from "../../../components/utils/DateFormatter";
import { useTopBranchCustomerReport } from "../../../hooks/useAppData";


const BranchCustomerReport = () => {
  const [branch_id, setBranchId] = useState("");
  const [period, setPeriod] = useState("this_month");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [metric, setMetric] = useState("value");
  const [limit, setLimit] = useState("");
  const [customer_type, setCustomerType] = useState("all");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const { mydata } = location.state || {};
  // console.log("my data", mydata);

  useEffect(() => {
    if (mydata && mydata.id) {
      setBranchId(parseInt(mydata.id));
    }
  }, [mydata]);

  // console.log("branch id", branch_id);
  const reportFilters = branch_id ? {
    period,
    metric: metric || "transactions",
    limit: limit || 10,
    customer_type,
    branch_id: parseInt(branch_id),
    ...(period === "custom" && startDate ? { start_date: startDate } : {}),
    ...(period === "custom" && endDate ? { end_date: endDate } : {}),
  } : null;

  const { data: reportResponse, isLoading: loading } = useTopBranchCustomerReport(reportFilters);
  const report = reportResponse?.data?.customers || reportResponse?.data || [];

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    // React Query auto re-fetches when reportFilters change via state updates
  };

  const handleClearDateFilter = () => {
    setStartDate("");
    setEndDate("");
    setMetric("value");
    setLimit("");
    // React Query auto re-fetches when state resets above
  }

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const columns = [
    {
      name: "Customer Name",
      selector: (row) => (row.customer_name ? row.customer_name.toUpperCase() : "UNKNOWN"),
      sortable: true,
      width: "250px",
    },
    {
      name: "Branch Name",
      selector: (row) => (row.branch_name ? row.branch_name.toUpperCase() : ""),
      sortable: true,
      width: "200px",
    },
    {
      name: "Phone",
      selector: (row) => row.customer_phone ? row.customer_phone : "NOT AVAILABLE",
      sortable: true,
      width: "120px",
    },
    {
      name: "Total Value",
      selector: (row) => CurrencyFormatter(row.total_value || 0),
      sortable: true,
      width: "180px",
    },

    {
      name: "Total Volume",
      selector: (row) => row.total_volume || 0,
      sortable: true,
      width: "150px",
    },
    {
      name: "Average Order Value",
      selector: (row) => CurrencyFormatter(row.average_order_value || 0),
      sortable: true,
      width: "200px",
    },
    {
      name: "First Purchase",
      selector: (row) =>
        row.first_purchase && !isNaN(Date.parse(row.first_purchase))
          ? new Date(row.first_purchase).toLocaleString()
          : "N/A",
      sortable: true,
      width: "220px",
    },
    {
      name: "Last Purchase",
      selector: (row) =>
        row.last_purchase && !isNaN(Date.parse(row.last_purchase))
          ? new Date(row.last_purchase).toLocaleString()
          : "N/A",
      sortable: true,
      width: "220px",
    }

  ];


  const filteredItems = report.filter((item) => {
    for (let key in item) {
      if (
        typeof item[key] === "string" &&
        item[key].toLowerCase().includes(filterText.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  });

  const data = filteredItems.map((category) => ({
    branch_name: category.branch_name ? category.branch_name : "NOT AVAILABLE",
    customer_type: category.customer_type ? category.customer_type : "NOT AVAILABLE",
    total_value: category.total_value ? CurrencyFormatter(category.total_value) : "NOT AVAILABLE",
    customer_name: category.customer_name ? category.customer_name : "NOT AVAILABLE",
    customer_phone: category.customer_phone ? category.customer_phone : "NOT AVAILABLE",
    total_value: category.total_value ? category.total_value : "NOT AVAILABLE",
    total_volume: category.total_volume ? category.total_volume : "NOT AVAILABLE",
    first_purchase: category.first_purchase ? category.first_purchase : "NOT AVAILABLE",
    last_purchase: category.last_purchase ? category.last_purchase : "NOT AVAILABLE",
  }));

  // Sort data based on creation date
  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Report
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">Top Customer</p>
                </li>
              </ol>
            </nav>
          </section>
          <form
            onSubmit={handleFilterSubmit}
            className="flex flex-wrap items-end gap-4 px-0 pt-4 mb-4"
          >
            <div>
              <label className="block text-sm text-gray-700 mb-1 ">Period</label>
              <select
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                className="border border-grey3 p-2 rounded-md w-48 py-3"
              >
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="this_week">This Week</option>
                <option value="last_week">Last Week</option>
                <option value="this_month">This Month</option>
                <option value="last_month">Last Month</option>
                <option value="custom">Custom</option>
              </select>
            </div>

            {period === "custom" && (
              <>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">
                    Start Date
                  </label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="border border-grey3 p-2 rounded-md"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-700 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="border border-grey3 p-2 rounded-md"
                    required
                  />
                </div>
              </>
            )}
            <div>
              <label className="block text-sm text-gray-700 mb-1">Metric</label>
              <select
                value={metric}
                onChange={(e) => setMetric(e.target.value)}
                className="border border-grey3 p-2 rounded-md w-48 py-3"
              >
                <option value="value">Value</option>
                <option value="frequency">Frequency</option>
                <option value="volume">Volume</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-700 mb-1">Limit</label>
              <input
                type="number"
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
                className="border border-grey3 p-2 rounded-md w-48 py-2"
                min={1}
                max={100}
              />
            </div>

            <button
              type="submit"
              className="bg-darkGreen2 hover:bg-darkGreen2 text-lGrey px-4 py-2 rounded-md"
            >
              Apply Filter
            </button>
            <button
              onClick={handleClearDateFilter}
              className="px-4 py-2 bg-orange1 text-lGrey rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Clear
            </button>
          </form>
          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search"
                value={filterText}
                onChange={handleFilter}
              />
            </div>

            <Link
              to="/operations/branch/list"
              className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              <span className="flex justify-center sm:justify-start mx-2">
                <List className="mr-2" />
                Back To List
              </span>
            </Link>

          </div>
          {loading ? (
            <Spinner />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No Branch Report found</div>}
            // expandableRows
            // expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};


export default BranchCustomerReport;






